import './sentry.ts'

import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from './utils/ChakraProvider.tsx'

import { AxiosInterceptor } from '@/api'
import { applyLocale, getLocaleFromPathname } from '@/utils/locale.ts'
import { oidKeycloakConfig } from '@/utils/oidConfig.ts'
import queryClient from '@/utils/queryClient.ts'
import { QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from 'react-oidc-context'

import Router from '@/utils/Router.tsx'
import '@fontsource/poppins/400.css'
import '@fontsource/poppins/600.css'
import '@fontsource/poppins/700.css'
import * as Sentry from '@sentry/react'
import 'leaflet/dist/leaflet.css'
import moment from 'moment'
import 'react-datetime/css/react-datetime.css'
import './i18n'
import './main.css'
// @ts-expect-error Node não encontra o arquivo, mas ele existe
import 'moment/dist/locale/pt-br.js'

moment.locale('pt-br')

applyLocale(getLocaleFromPathname(globalThis.location.pathname))

globalThis.window.onerror = (_message, _source, _lineno, _colno, error) => {
  Sentry.captureException(error || _message)
}

globalThis.window.onunhandledrejection = (event) => {
  Sentry.captureException(event.reason)
}

globalThis.window.addEventListener('DOMContentLoaded', () => {
  try {
    ReactDOM.createRoot(document.getElementById('root') as HTMLElement, {
      onUncaughtError: Sentry.reactErrorHandler(),
      onCaughtError: Sentry.reactErrorHandler(),
      onRecoverableError: Sentry.reactErrorHandler(),
    }).render(
      <React.StrictMode>
        <AuthProvider {...oidKeycloakConfig}>
          <Provider>
            <QueryClientProvider client={queryClient}>
              <AxiosInterceptor>
                <Router />
              </AxiosInterceptor>
            </QueryClientProvider>
          </Provider>
        </AuthProvider>
      </React.StrictMode>
    )
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e)
    Sentry.captureException(e)
  }
})
